import backofficeService from '../../api/backoffice'

export default {
  balanceByDepartment(params) {
    return backofficeService.Api().get(`report/department/all`, { params })
      .then(response => {
        return response.data
      })
      .catch((error) => { throw error })
  },
  donationPayments(params) {
    return backofficeService.Api().get(`report/donation/payment`, { params })
      .then(response => {
        return response.data
      })
      .catch((error) => { throw error })
  },
  getSaleByCategory(params) {
    console.log('params', params)
    return backofficeService.Api().get(`sales/category`, { params })
      .then(response => {
        return response.data
      })
      .catch((error) => { throw error })
  },
  getInventory(params) {
    return backofficeService.Api().get(`report/inventory/stock`, { params })
      .then(response => {
        return response.data
      })
      .catch((error) => { throw error })
  },
  getAvalibaleSerial(params) {
    return backofficeService.Api().get(`report/inventory/availableSerial`, { params })
      .then(response => {
        return response.data
      })
      .catch((error) => { throw error })
  },
  getProduct(params) {
    return backofficeService.Api().get(`sales/product`, { params })
      .then(response => {
        return response.data
      })
      .catch((error) => { throw error })
  },
	getAttendanceReport(params) {
    return backofficeService.Api().get(`attendance/bydate`, { params })
      .then(response => {
        return response.data
      })
      .catch((error) => { throw error })

	}
}
